import MuiZoom, { type ZoomProps } from "@mui/material/Zoom";

export type { ZoomProps };

export function Zoom(props: ZoomProps) {
  return <MuiZoom {...props} />;
}
